import { render, staticRenderFns } from "./RegisterTc.vue?vue&type=template&id=24d3ba01&"
import script from "./RegisterTc.vue?vue&type=script&lang=js&"
export * from "./RegisterTc.vue?vue&type=script&lang=js&"
import style0 from "./RegisterTc.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports